import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Drag from "./dragNdDrop";
import { audio } from "../../action/user_action";
import Header from "../common/HeaderAfterLogin";
import AuthHeader from "../salesUser/common/AuthHeader";
import { CommonModelImpl } from "../common/CommonModel";
import UserSideMenu from "../../menu/UserSideMenu";
import {
  axiosInstnace as axios,
  getDaysForDaysPackage,
  calculateAudioDuration,
} from "../../util/util";
import { endPoints, domain } from "../../config";
import { history } from "../../history/history";
import Model from "./model";
import NewModel from "./newModel";
import MultipleAudioModel from "./multipleAudioModel";
import useModel from "./useModel";
import { addDays, getDay } from "date-fns";
import { fromJS } from "immutable";
import SalesUserSideMenu from "../../menu/SalesUserSideMenu";
import { ShowStations } from "./ShowStations";

const Campaign = (props) => {
  //Set initial state
  const [uploadAudio] = useState("drag_nd_drp");
  // const [audioBrief, handleAudioBrief] = useState(undefined);
  const [packageDetails, handlePackageDetails] = useState([
    props.location.state.packageDetails,
  ]);
  const [timelimits, handleTimeLimts] = useState();
  const [userinfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [salesuserinfo, setSalesUserInfo] = useState(
    JSON.parse(localStorage.getItem("salesUserInfo"))
  );
  const [station, handleStation] = useState(undefined);
  const [stations, handleStations] = useState(undefined);
  const [audioDuration, handleAudioDuration] = useState(null);
  const [uploadedAudio, handleuploadedAudio] = useState(undefined);

  const [bookingType, setBookingType] = useState("Normal");
  const [showPrimeMsg, setShowPrimeMsg] = useState(false);
  const [option, handleOption] = useState(true);

  const [previousAudioOption, handlepreviousAudioOption] = useState(false);
  const [helpbigfmAudioOption, handlehelpbigfmAudioOption] = useState(false);
  const [uploadAudioleterOption, handleuploadAudioleterOption] = useState(
    false
  );

  const [packageCost, handlePackageCost] = useState(undefined);
  const [taxes, handleTaxes] = useState(undefined);
  const [totalCost, handleTotalCost] = useState(undefined);
  const [audioArray] = useState([10, 15, 20, 25, 30]);
  const [audioCost, handleAudioCost] = useState(undefined);
  const [audioUrl, handleAudioUrl] = useState(undefined);
  const [audioDiscount, handleAudioDiscount] = useState(undefined);
  const [createAudio, handleCreateAudio] = useState(undefined);
  const [createWithoutAudio, handleCreateWithoutAudio] = useState(undefined);
    const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);

  const [objectivesArray] = useState([
    "Generate Brand Awareness",
    "Drive Sales",
    "Brand Launch",
    "Other",
  ]);
  const [objective, handleObjective] = useState("Generate Brand Awareness");
  const [uploadedAudios, handleUploadedAudios] = useState([]);
  const [selectedPreviousAudio, handleSelectedPreviousAudio] = useState("");
  const [audioLength, handleAudioLength] = useState(10);
  const [type, handleType] = useState("");
  const [couponCode, handleCouponCode] = useState("");
  const [nonFCTCode, handleNONFCTCode] = useState("");
  const [invalid, handleInvalid] = useState(false);
  const [nonFCTInvalid, handleNonFCTInvalid] = useState(false);
  const [validClass, handleValidClass] = useState("none");
  const [nonFCTValidClass, handleNonFCTValidClass] = useState("none");
  const [inputClass, handleInputClass] = useState("");
  const [nonFCTInputClass, handleNonFCTInputClass] = useState("");
  const [expiredCoupon, handleExpiredCoupon] = useState(false);
  const [expiredNONFCTCode, handleExpiredNONFCTCode] = useState(false);
  const [couponAmount, handCouponAmount] = useState(undefined);
  const [fileName, handleFileName] = useState("");
  const [fileSizeWithLimit, setFileSizeWithLimit] = useState("");
  const [fileSize, handleFileSize] = useState("");
  const campaignName = useRef(undefined);
  // const audioBrief = useRef(undefined);
  const brandName = useRef(undefined);
  const [productName, handleProductName] = useState(undefined);
  const sallerId = useRef(undefined);

  const [firstCount, handleFirstCount] = useState(1);
  const [firstOption, handleFirstOption] = useState(true);
  const [couponPercentage, handleCouponPercentage] = useState(undefined);
  const [nonFCTCodeAmount, handleNonFCTCodeAmount] = useState(undefined);
  const [couponType, handleCouponType] = useState(undefined);
  const [couponDiscount, handleCouponDiscount] = useState(undefined);
  const [packageDiscount, handlePackageDiscount] = useState(undefined);
  const [packageDays, handlePackageDays] = useState(undefined);
  const [minStartDate, handleMinStartDate] = useState(null);
  const [fileLimitModel, handleFileLimitModel] = useState(false);
  const [minValueMet, handleminValueMet] = useState(false);
  const [customMsg, handleCustomMsg] = useState(
    `Alert ! Creative audio length does not match audio duration of the selected package. Click on "Change package" to change the package duration or to re upload the audio with exact audio length matching the package. You can also click on  "Accept" to proceed with revised cost calculated as per current audio length`
  );
  const [minAmountMsg, handleMinAmountMsg] = useState(
    `Alert ! Package Cost are lower than the Minimum Amount required to create a campaign. Please upload the audio with correct duration`
  );
  const [primeAmountMsg, handleprimeAmountMsg] = useState(
    `Note ! Package Cost of Custom Time Band is more than the Regular. Click on "Accept" to Proceed with the revised cost. You can click on "Decline" to continue with the Regular Band Price`
  );
  const [actualAudioLength, handleAcutualAudioLength] = useState(undefined);
  const [isCampaignError, handleIsCampaignError] = useState(false);
  const [isBrandError, handleIsBrandError] = useState(false);
  const [isProductError, handleIsProductError] = useState(false);
  const [isSaleIdError, handleIsSaleIdError] = useState(false);
  const [isDateError, handleIsDateError] = useState(false);
  const [previousAudio, handlePreviousAudio] = useState([]);
  const [industryList, handleIndustryList] = useState([]);
  const [defaultSalesUser, handleDefaultSalesUser] = useState('');

  const [startDate, handleStartDate] = useState(null);
  const [selectedCustomfrom, setSelectedCustomfrom] = useState(null);
  const [selectedCustomto, setSelectedCustomto] = useState(null);
  const [selectedBands, setSelectedBands] = useState([]);
  const isWeekday = (date) => {
    const day = getDay(date);
    return day !== 0 && day !== 6;
  };
  const { isShowing, toggle } = useModel();

  const { isNewShowing, newToggle } = useModel();
  const [selectedMultiDurationAudio, handleSelectedMultiDurationAudio] = useState(false);
  
  const { isMultipleAudioShowing, multipleAudioToggle } = useModel();
  const [multipleAudios, handleMultipleAudios] = useState(undefined);

  useEffect(() => {
    getPackage();
    getIndustryList();
    document.getElementById("OwnRadio").checked = true;
    document.getElementById("Normal").checked = true;
    if (salesuserinfo && userinfo.email === salesuserinfo.email) {
      sallerId.current.value = salesuserinfo.email;
    }
    if (
      props.location.state.packageDetails &&
      props.location.state.packageDetails.startTime &&
      props.location.state.packageDetails.endTime
    ) {
      let start = moment(props.location.state.packageDetails.startTime).format(
        "HH"
      );
      let end = moment(props.location.state.packageDetails.endTime).format(
        "HH"
      );
      let exactEnd;
      if (end < start) {
        exactEnd = JSON.parse(JSON.stringify(end));
        end = 23;
      }
      let timebands = [];
      for (let i = start; i <= end; i++) {
        timebands.push(setHours(setMinutes(new Date(), 0), i));
      }
      if (exactEnd) {
        for (let i = 0; i <= exactEnd; i++) {
          timebands.push(setHours(setMinutes(new Date(), 0), i));
        }
      }
      handleTimeLimts(timebands);
    }
  }, []);

  const hideshowstations = (e) => {
    handleshowstationlist(!showstationlist);
  };

  useEffect(() => {
    checkMiniumValue();
  }, [packageCost]);
  //Getting the audio array
  useEffect(() => {
    setAudioCost();
  }, [props.audios]);

  useEffect(() => {
    getMinDate();
  });

  useEffect(() => {
    if(helpbigfmAudioOption === true){
      calculateAgain(packageDetails[0].audioDuration)
    }
  }, [helpbigfmAudioOption])
  
  useEffect(() => {
    let compaignPrevData = localStorage.getItem("compaignHistory");
    //console.log(JSON.parse(compaignPrevData));
    if (compaignPrevData != null && compaignPrevData != "") {
      let prev_data = JSON.parse(compaignPrevData);
      campaignName.current.value = prev_data.compaignName;
      // audioBrief.current.value = prev_data.audioBrief;
      brandName.current.value = prev_data.brandName;
      handleProductName(prev_data.productName);
      sallerId.current.value = prev_data.sallerId;
      if (prev_data.date) {
        handleStartDate(new Date(prev_data.date));
      }
    }
  }, []);

  const checkMiniumValue = () => {
    if (!couponAmount) {
      if (packageCost < packageDetails[0].minValue) {
        handleminValueMet(true);
      } else {
        handleminValueMet(false);
      }
    }
  };

  //Calculate the audio cost
  const setAudioCost = () => {
    let packageDetailsInfo = packageDetails[0];
    let packageCost =
      packageDetailsInfo.type == "Weekly" ||
      packageDetailsInfo.type == "Weekend"
        ? packageDetailsInfo.totalCost
        : packageDetailsInfo.totalCost -
          (packageDetailsInfo.discount * packageDetailsInfo.totalCost) / 100;
    if (bookingType === "custom") {
      packageCost =
        packageCost + packageCost * (packageDetailsInfo.customrodp / 100);
    }
    let audioCost =
      props.audios && props.audios.size > 0
        ? props.audios.toJS().cost
        : undefined;
    let audioDiscount =
      props.audios && props.audios.size > 0
        ? props.audios.toJS().discountValue
        : undefined;
    let taxes = helpbigfmAudioOption
      ? Math.round((18 * (packageCost + audioCost)) / 100)
      : Math.round((18 * packageCost) / 100);
    //  && uploadAudioleterOption ? Math.round((18 * (packageCost - audioCost)) / 100): Math.round((18 * packageCost - audioCost) / 100)
    if (firstCount === 1) {
      setCostValue(packageCost, taxes, audioCost, 0, undefined, true);
    } else {
      setCostValue(packageCost, taxes, audioCost, 0, undefined, option);
    }
    handleFirstCount(firstCount + 1);
  };

  const getIndustryList = async () => {
    const response = await axios.get(`${endPoints.getIndustryList}`);
    let industryList = response.data.data.data;
    handleIndustryList(industryList);
    handleProductName(industryList[0].name);
    handleDefaultSalesUser(response.data.data.defaultSalesUser);
  };
  const closeExistingAudioPopup = () => {
    newToggle(!isNewShowing);
    handleOption(true);
    handleFirstOption(true);
    handlepreviousAudioOption(false);
    handlehelpbigfmAudioOption(false);
    handleuploadAudioleterOption(false);
    handleMinStartDate(null);
    getPackage();
    removeFile();
    let taxvalue = Math.round((18 * packageCost) / 100);
    setCostValue(packageCost, taxvalue, undefined, undefined, undefined, true);
  };

  const closeMultipleAudioPopup = () => {
    multipleAudioToggle();
  };

  const toggleNewMode = async () => {
    newToggle(!isNewShowing);
    // getUploadedFile();
    console.log(localStorage.getItem("ExistingFileUrl"));
    console.log(localStorage.getItem("ExistingAudioFileSize"));
    handleAudioUrl(localStorage.getItem("ExistingFileUrl"));
    handleUploadedAudios(JSON.parse(localStorage.getItem("ExistingAudios")));
    handleFileSize(Number(localStorage.getItem("ExistingAudioFileSize")));
    handleAcutualAudioLength(
      Number(localStorage.getItem("ExistingAudioDuration"))
    );
    let size = bytesToSize(
      Number(localStorage.getItem("ExistingAudioFileSize"))
    );
    setFileSizeWithLimit(size);
    let audio_duration = Number(localStorage.getItem("ExistingAudioDuration"));
    handleAudioLength(Number(localStorage.getItem("ExistingAudioLength")));
    let audioLengthCalculated = await calculateAudioDuration(audio_duration);
    handleAudioDuration(audioLengthCalculated);
    handleSelectedPreviousAudio(true)
    debugger
    if (
      (!audioDuration &&
        packageDetails[0].type === "Rotation Based" &&
        audioLengthCalculated !== packageDetails[0].audioDuration) ||
      (audioDuration && audioLengthCalculated !== audioDuration)
    ) {
      handleFileLimitModel(true);
    }
  };

  const toggleMultipleAudioModel = async (audioData) => {
    multipleAudioToggle();
    let multipleAudioData = audioData;

    handleMultipleAudios(multipleAudioData);
  };
  const setToRegular = () => {
    setBookingType("Normal");
    setShowPrimeMsg(false);
    getPackage();
  };
  const setToPrime = () => {
    setShowPrimeMsg(false);
    getPackage();
  };

  //Fetching the package
  const getPackage = async () => {
    let packageDetailsInfo = packageDetails[0];
    console.log("Package Details : " + JSON.stringify(packageDetailsInfo));
    handlePreviousAudio(packageDetailsInfo.campaigns);
    handleStation(packageDetailsInfo.station);
    handleStations(packageDetailsInfo.stations);
    let packageCost =
      packageDetailsInfo.type == "Weekly" ||
      packageDetailsInfo.type == "Weekend"
        ? packageDetailsInfo.totalCost
        : packageDetailsInfo.totalCost -
          (packageDetailsInfo.discount * packageDetailsInfo.totalCost) / 100;
    if (bookingType === "custom") {
      packageCost =
        packageCost + packageCost * (packageDetailsInfo.customrodp / 100);
    }
    let taxes;
    if(couponDiscount){
      taxes = Math.round((18 * (packageCost- couponDiscount)) / 100);
    }else{
      taxes = Math.round((18 * packageCost) / 100);
    }
    handlePackageCost(Math.round(packageCost));
    // debugger
    handleType(packageDetailsInfo.type);
    await setCostValue(packageCost, taxes, undefined, undefined, undefined);
    handlePackageDiscount(packageDetailsInfo.discount);
    handlePackageDays(
      packageDetailsInfo.days ? packageDetailsInfo.days : undefined
    );
    props.audio(
      packageDetailsInfo.type == "Rotation Based"
        ? Number(packageDetailsInfo.audioDuration)
        : Number(10)
    );
  };

  //Set cost value ehile creating a campaign

  const setCostValue
   = (
    packageCost,
    taxes,
    audioCosts,
    audioDiscounts,
    createAudio,
    options
  ) => {
    let nonFCTAmounts = nonFCTCodeAmount ? nonFCTCodeAmount : 0;
    // debugger;
    if(couponDiscount || nonFCTCodeAmount){
      taxes = Math.round(packageCost - (couponAmount ? couponAmount : 0) + (nonFCTAmounts ? nonFCTAmounts : 0)) * 0.18
      taxes = Math.round(taxes)
      if(helpbigfmAudioOption){
        taxes = taxes + Math.round(audioCost * 0.18)
      }
    }
    let totalCost = Number(packageCost) + Number(nonFCTAmounts) + (taxes ? Number(taxes) : 0);
    let audioTotal =
      (audioCosts ? audioCosts : audioCost) -
      (audioDiscounts ? audioDiscounts : audioDiscount);
    if (options || previousAudioOption) {
      audioTotal = 0;
      let amountToBePaid = totalCost;
    } else {
      //console..log('Pay for audio');
      let pendingCost =
        Number(totalCost) - (Number(packageCost) + (18 * packageCost) / 100);
      let amountToBePaid = totalCost - pendingCost;

      // handleFirstOption(false);
      // handlepreviousAudioOption(false);
    }
    let couponAmounts = 0;

    if (couponAmount && couponType === "percentage") {
      couponAmounts = 
      Math.round(
        (couponDiscount * Number(packageCost)) / 100
      );
      handCouponAmount(couponAmounts);
    } else if (couponAmount && couponType === "Flat Rate") {
      couponAmounts = Math.round(couponDiscount);
      handCouponAmount(couponAmounts);
    }
    handlePackageCost(Math.round(packageCost));
    handleTaxes(taxes);
    handleCreateAudio(audioCosts ? audioCosts : audioCost);
    handleAudioCost(audioCosts ? audioCosts : audioCost);
    // handleCreateWithoutAudio(packageCost-audioCost);
    handleAudioDiscount(0);
    handleTotalCost(
      // Math.round(Number(totalCost) + Number(audioTotal) - Number(couponAmounts))
      Math.round(Number(totalCost) + (audioCosts ? Number(audioTotal) : 0) - Number(couponAmounts))
    );
  };

  //Fetch audio
  const getAudio = (e) => {
    //console..log("Audio Length: " +e.target.value);
    props.audio(Number(e.target.value));
    handleAudioLength(Number(e.target.value));
  };

  const getMinDate = () => {
    let currentTime = new Date().getHours();

    if (!minStartDate) {
      if (currentTime < 15) {
        const day = getDay(new Date());
        console.log("Day", day);
        if (day == 5) {
          handleMinStartDate(addDays(new Date(), 3));
        } else if (day == 6) {
          handleMinStartDate(addDays(new Date(), 3));
        } else if (day == 0) {
          handleMinStartDate(addDays(new Date(), 2));
        } else {
          handleMinStartDate(addDays(new Date(), 1));
        }
      }
      if (currentTime >= 15) {
        const dayAfter = getDay(new Date());
        console.log("DayAfter ", dayAfter);

        if (dayAfter == 5) {
          handleMinStartDate(addDays(new Date(), 4));
        } else if (dayAfter == 6) {
          handleMinStartDate(addDays(new Date(), 3));
        } else {
          handleMinStartDate(addDays(new Date(), 2));
        }
      }
    }
  };

  //Get min date for generate a file through bigFM
  const getMinDateBassedOnTypeOfFile = () => {
    console.log("Get min date based on type of file");
    let currentTime = new Date().getHours();
    if (startDate) {
      let dayDiff = Math.floor(
        (new Date(startDate).getTime() - new Date().getTime()) /
          (24 * 60 * 60 * 1000)
      );
      if (dayDiff < 2) {
        handleStartDate(null);
      }
      if (currentTime < 15) {
        const day = getDay(new Date());
        console.log("Day", day);
        if (day == 5) {
          // Friday
          handleMinStartDate(addDays(new Date(), 4));
        } else if (day == 6) {
          //Saturday
          handleMinStartDate(addDays(new Date(), 4));
        } else {
          handleMinStartDate(addDays(new Date(), 3));
        }
      }
      if (currentTime >= 15) {
        const dayAfter = getDay(new Date());
        console.log("DayAfter ", dayAfter);

        if (dayAfter == 4) {
          //Thursday
          handleMinStartDate(addDays(new Date(), 4));
        } else if (dayAfter == 5) {
          //Friday
          handleMinStartDate(addDays(new Date(), 4));
        } else if (dayAfter == 6) {
          handleMinStartDate(addDays(new Date(), 3));
        } else {
          handleMinStartDate(addDays(new Date(), 3));
        }
      }
    } else {
      if (currentTime < 15) {
        const day = getDay(new Date());
        console.log("Day", day);
        if (day == 5) {
          // Friday
          handleMinStartDate(addDays(new Date(), 4));
        } else if (day == 6) {
          //Saturday
          handleMinStartDate(addDays(new Date(), 4));
        } else {
          handleMinStartDate(addDays(new Date(), 3));
        }
      }
      if (currentTime >= 15) {
        const dayAfter = getDay(new Date());
        console.log("DayAfter ", dayAfter);

        if (dayAfter == 4) {
          //Thursday
          handleMinStartDate(addDays(new Date(), 5));
        } else if (dayAfter == 5) {
          //Friday
          handleMinStartDate(addDays(new Date(), 5));
        } else if (dayAfter == 6) {
          handleMinStartDate(addDays(new Date(), 4));
        } else {
          handleMinStartDate(addDays(new Date(), 3));
        }
      }
    }
  };

  const handleDate = (date) => {
    handleStartDate(date);
  };

  const handleChange = (date, e) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }

    const { onChange } = date;

    if (onChange) {
      onChange(date);
    }
  };

  // const handleChangeAudio = event =>{
  //   console.log(event.target.value);
  //   handleAudioBrief(event.target.value);
  // }

  // const handleChangeAudio = event => {
  //   handleAudioBrief(event.target.value);
  // }

  //Calculate total seconds after upload a file
  const handleTotalSecondsAfterUpload = async (audioDuration) => {
    let { rodp, rotationPerDay, days, discount, stations } = packageDetails[0];
    // console.log(packageDetails[0]);
    let totalSecondages = rotationPerDay * audioDuration * days;
    totalSecondages = stations && stations.length > 0? totalSecondages * stations.length: totalSecondages
    const response = await axios.get(
      `${endPoints.getCustomPackage}?secondages=${totalSecondages}`
    );
    if (response && response.data.statusCode === 200) {
      let { data } = response.data.data;
      if (data[0]) {
        discount = data[0].discount;
      }
    }
    let fctPerDay = rotationPerDay * audioDuration;
    let actfctPerDay = stations && stations.length > 0? fctPerDay * stations.length: fctPerDay
    let discountedCost = Math.round(
      (discount * (actfctPerDay * (rodp / 10) * days)) / 100
    );
    let totalCost = Math.round(actfctPerDay * (rodp / 10) * days);
    let packageCost =
      packageDetails[0].type == "Weekly" || packageDetails[0].type == "Weekend"
        ? totalCost
        : Math.round(actfctPerDay * (rodp / 10) * days) - discountedCost;
    let packageDetailsInfo = Object.assign({}, packageDetails[0], {
      secondages: totalSecondages,
      totalCost,
      discountedCost,
      discount,
      fctPerDay,
    });
    // debugger
    let taxes = helpbigfmAudioOption
    ? Math.round((18 * (packageCost + audioCost)) / 100)
    : Math.round((18 * packageCost) / 100);
    handlePackageCost(packageCost);
    handleTotalCost(totalCost)
    handlePackageDetails([packageDetailsInfo]);
    setCostValue(packageCost, taxes)
  };

  //Calculate audio realted details
  const calculateAgain = async (audioDuration) => {
    if (audioDuration) await handleTotalSecondsAfterUpload(audioDuration);
    if(helpbigfmAudioOption){
      await getPackage();
    }
    // await setAudioCost();
  };

  //Checking file file limit
  const acceptFileExccedLimit = async () => {
    handleFileLimitModel(false);
    debugger
    let calDuration = await calculateAudioDuration(audioDuration);
    calculateAgain(calDuration);
    debugger;
  };

  //Get audio duration
  const getAudioDuration = (file) => {
    var reader = new FileReader();
    reader.onload = function() {
      //console..log('Get Audio duration - ' +reader.result);
      var audio = new Audio(reader.result);
      audio.onloadedmetadata = async () => {
        let audio_duration = parseInt(Math.floor(audio.duration));
        handleAcutualAudioLength(audio_duration);
        audio_duration = await calculateAudioDuration(audio_duration);
        handleAudioDuration(audio_duration);
        if (
          packageDetails[0].type == "Rotation Based" &&
          audio_duration !== packageDetails[0].audioDuration
        ) {
          handleFileLimitModel(true);
        }
      };
    };
    reader.readAsDataURL(file);
  };

  //Upload a file
  const getUploadedFile = (files) => {
    console.log("Audio File>>>", files);
    let sizes = files.map((e) => {
      return e.size;
    });
    sizes = [...new Set(Array.from(sizes))];
    if (sizes.length > 1) {
      handleToastError("Please select the audios in same duration");
      return;
    } else {
      var size = bytesToSize(files[0].size);
      //console..log(size);
      handleUploadedAudios(files);
      setFileSizeWithLimit(size);
      getAudioDuration(files[0]);
      handleuploadedAudio(files[0]);
      handleFileName(files[0].name);
      handleFileSize(files[0].size);
    }
  };

  // Show file size in bytes
  const bytesToSize = (bytes, decimals = 2) => {
    var sizes = ["Bytes", "KB", "MB", "GB"];
    if (bytes == 0) return "0 bytes";
    var dm = decimals < 0 ? 0 : decimals;
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed()) + " " + sizes[i];
  };

  //Remove a file
  const removeFile = () => {
    handleFileLimitModel(false);
    handleOption(true);
    handleuploadedAudio(false);
    handleFileSize("");
    handleFileName("");
    handlepreviousAudioOption(false);
    handleUploadedAudios([]);
    localStorage.setItem("ExistingAudioUrl", "");
    localStorage.setItem("ExistingAudioLength", "");
    localStorage.setItem("ExistingAudioDuration", "");
    localStorage.setItem("ExistingAudioFileSize", "");
    document.getElementById("OwnRadio").checked = true;
    // debugger
    handleAudioDuration(packageDetails[0].audioDuration)
    if (packageDetails[0].type == "Rotation Based") {
      calculateAgain(packageDetails[0].audioDuration);
    }
  };
  //Remove a file
  const removeFileInCollection = (evt) => {
    handleUploadedAudios(
      uploadedAudios.filter((e) => {
        return e.path !== evt;
      })
    );
  };

  //Change slot
  const changeSlot = () => {
    //console..log(startDate);
    history.push("/package", {
      city: station,
      lon: props.location.state.packageDetails.lon,
      lat: props.location.state.packageDetails.lat,
    });
  };

  //match package ith selected package
  const matchPackageDiscount = async () => {
    let countDays =
      type == "Day Based" ? getDaysForDaysPackage(packageDays) : packageDays;
    try {
      const data = await axios.get(endPoints.matchPackageDiscount, {
        params: {
          days: countDays,
          type,
          fctPerDay: packageDetails[0].fctPerDay,
          userEmail: JSON.parse(localStorage.getItem("userInfo")).email,
        },
      });
      const result = data.data.data.data;
      if (result && result[0].discount != packageDiscount) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Submit package
  const goToKyc = () => {
    console.log(
      "Pending amount - ",
      packageDetails[0].totalCost - (audioCost + taxes)
    );
    console.log(totalCost);
    console.log(audioCost);
    console.log(option);
    console.log(helpbigfmAudioOption);
    console.log(uploadAudioleterOption);
    console.log(previousAudioOption);
    let audioOption = option
      ? "Own Audio"
      : helpbigfmAudioOption
      ? "Bigfm Audio"
      : previousAudioOption
      ? "Existing Audio"
      : uploadAudioleterOption
      ? "Upload audio later"
      : selectedMultiDurationAudio ?
      "Multi Duration Audio" : "";

    let taxvalue = Math.round((18 * audioCost) / 100);
    console.log(taxvalue);
    let createWithoutAudio = packageCost - (audioCost - taxvalue);
    console.log(createWithoutAudio);
    let pendingAmount = totalCost - (audioCost + taxvalue);
    let totalAudioCost = audioCost + taxvalue;
    let name = campaignName ? campaignName.current.value : undefined;
    let brand = brandName ? brandName.current.value : undefined;
    let product = productName ? productName : undefined;
    let sallerIdValue = sallerId && sallerId.current.value ? sallerId.current.value : defaultSalesUser;
    let amount = totalCost - taxes;
    if (couponAmount) {
      amount = amount + couponAmount;
    }
    let exitingFileName = "";
    let multiDurationAudioDetail = undefined;

    if (localStorage.getItem("ExistingAudioUrl")) {
      exitingFileName = localStorage.getItem("ExistingAudioUrl");
    }

    if(selectedMultiDurationAudio){
      multiDurationAudioDetail = multipleAudios;
    }

    let compaignData = {
      files: uploadedAudios.length > 0 ? uploadedAudios : uploadedAudio,
      days: packageDays,
      fileName: exitingFileName ? exitingFileName : fileName,
      fileSize,
      isMultiDurationAudio: selectedMultiDurationAudio,
      multiDurationAudioDetail: multiDurationAudioDetail,
      name,
      brand,
      product,
      objective,
      taxes,
      rodp:
        bookingType === "custom" && selectedBands.length > 0
          ? packageDetails[0].rodp  +
            (packageDetails[0].rodp  * (packageDetails[0].customrodp / 100))
          : packageDetails[0].rodp,
      audioLength:
        packageDetails[0].type == "Rotation Based" &&
        helpbigfmAudioOption &&
        uploadAudioleterOption
          ? packageDetails[0].audioDuration
          : helpbigfmAudioOption
          ? audioLength
          : audioDuration,
      audioDuration:
        packageDetails[0].type == "Rotation Based" &&
        helpbigfmAudioOption &&
        uploadAudioleterOption
          ? packageDetails[0].audioDuration
          : audioDuration
          ? audioDuration
          : 0,
      couponPercentage: couponPercentage ? couponPercentage : 0,
      nonFCTCodeAmount: nonFCTCodeAmount ? nonFCTCodeAmount : 0,
      bigFmAudio: helpbigfmAudioOption,
      audioCost:
        firstOption || previousAudioOption || selectedMultiDurationAudio
          ? 0
          : createAudio
          ? createAudio
          : audioCost,
      // createWithoutAudio: uploadAudioleterOption ? 0 : audioCost,
      createWithoutAudio: uploadAudioleterOption,
      audioStatus: helpbigfmAudioOption ? "Requested" : "Uploaded",
      pendingAmount: firstOption || previousAudioOption || selectedMultiDurationAudio ? 0 : pendingAmount,
      discount: 0,
      // discount: props.audios.toJS().discount,
      // audioDiscount: firstOption ? 0 : audioDiscount ? audioDiscount : 0,
      audioDiscount: 0,
      // audioTotalCost: firstOption ? 0 : createAudio ? createAudio : audioCost - props.audios.toJS().discountValue,
      audioTotalCost:
        firstOption || previousAudioOption || selectedMultiDurationAudio
          ? 0
          : createAudio
          ? createAudio
          : audioCost,
      totalCost,
      type,
      amount,
      startDate,
      station: stations && stations.length > 0? stations: station,
      sallerId: sallerIdValue,
      status: "Pending",
      audioOption: audioOption,
      audioUrl,
      couponCode,
      nonFCTCode,
      bookingType,
      timebands:
        bookingType === "custom" && selectedBands.length > 0
          ? selectedBands
          : [],
          indivrodps: packageDetails[0].stationwisedetails
    };
debugger
    if (couponAmount) {
      compaignData.couponDiscount = couponAmount;
    }
    if (packageDetails[0].fctPerDay) {
      compaignData.fctPerDay = packageDetails[0].fctPerDay;
    }
    if (packageDetails[0].secondages) {
      compaignData.secondages = packageDetails[0].secondages;
    }
    if (packageDetails[0].totalCost) {
      compaignData.totalPackageCost = packageDetails[0].totalCost;
    }
    if (packageDetails[0].discountedCost) {
      compaignData.packageDiscountedCost = packageDetails[0].discountedCost;
    }
    if (packageDetails[0].discount) {
      compaignData.additionalBenefits = packageDetails[0].discount;
    }
    if (
      packageDetails[0].rotationPerDay &&
      packageDetails[0].rotationPerDay > 0
    ) {
      compaignData.rotationPerDay = packageDetails[0].rotationPerDay;
    }
    
    history.push("/kyc", { compaignData, packageCost });

    // if(localStorage.getItem('compaignHistory') || localStorage.getItem('slots')) {
    //   localStorage.clear();
    // }
  };

  //Error handling
  const handleToastError = (error) => {
    toast.error(error, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: false,
      hideProgressBar: true,
      toastId: "1",
    });
  };

  //Pay ammount
  const payAmount = async () => {
    let name = campaignName ? campaignName.current.value : undefined;
    let brand = brandName ? brandName.current.value : undefined;
    let product = productName ? productName : undefined;
    let sallerIdValue = sallerId ? sallerId.current.value : undefined;

    let domainArr = ["gmail.com", "radiobigfm.com"];
    console.log(startDate);
    if (name.length === 0) {
      handleIsCampaignError(true);
    }
    if (brand.length === 0) {
      handleIsBrandError(true);
    }
    if (product.length === 0) {
      handleIsProductError(true);
    }
    if (!startDate) {
      handleIsDateError(true);
      handleToastError("All Fields Are Mandatory");
      return;
    }
    if (!uploadedAudio && !createAudio && !CreateWithoutAudio) {
      handleToastError("All Fields Are Mandatory");
      return;
    }
    if (firstOption && fileSize.length === 0 && fileName.length === 0) {
      handleToastError("Please upload audio file");
      return;
    }

    /* if (previousAudioOption && (fileSize.length === 0) && (fileName.length === 0) && (!toast.isActive("1"))) {
        handleToastError("Please upload audio file");
        return;
    }*/
    if (previousAudioOption && localStorage.getItem("ExistingAudioUrl")) {
      let existFile = localStorage.getItem("ExistingAudioUrl");
      console.log("existFile", existFile);
      // handleFileName(existFile);
    } else if (
      previousAudioOption &&
      localStorage.getItem("ExistingAudioUrl") == "" &&
      uploadedAudios.length == 0
    ) {
      handleToastError("Please upload audio file");
      return;
    } else {
      localStorage.setItem("ExistingAudioUrl", "");
    }

    if (selectedMultiDurationAudio && multipleAudios.length == 0) {
      handleToastError("Please upload multi duration audio");
      return;
    }
    //   if (firstOption && (fileSize.length === 0) && (fileName.length === 0) && (!toast.isActive("1"))) {
    //     handleToastError("Please upload audio file");
    //     return;
    // }

    // let salerDomainArr= sallerIdValue? sallerIdValue.split('@'): [];
    //&& domainArr.indexOf(salerDomainArr[1].toLowerCase() === -1)
    if (sallerIdValue && sallerIdValue != "") {
      if (
        !sallerIdValue
          .trim()
          .toLowerCase()
          .endsWith("gmail.com")
      ) {
        let result = await checkIfUserAlreadyExists(sallerIdValue);
        if (result.data.data && result.data.data.length <= 0) {
          handleIsSaleIdError(true);
          handleToastError("Please enter valid Sales Representative ID");
          return;
        }
      } else {
        let user = {
          email: sallerIdValue,
        };
        const result = await axios.post(endPoints.checkUserExists, user);

        if (result.data.data && result.data.data.length > 0) {
          // handleIsSaleIdError(true);
          handleToastError("Please enter valid Sales Representative ID");
          return;
        }
      }
    }
    if((!selectedBands || selectedBands.length == 0) && bookingType === "custom"){
     handleToastError("Please Select the Time Bands");
      return;
      }
    if (startDate) {
    }

    if (
      name.length === 0 ||
      brand.length === 0 ||
      product.length === 0 ||
      (!uploadedAudio && !createAudio && !CreateWithoutAudio)
    ) {
      return;
    }

    /*if (firstOption && previousAudioOption  && (fileSize.length === 0) && (fileName.length === 0)) {
      return;
    }*/

    if (packageDetails[0].type == "Rotation Based") {
      goToKyc();
    } else {
      //Package discount check commented by Karthick, as the check may return total days may differ from days selected in day package.
      // let packageDiscountCheck = await matchPackageDiscount();
      // if (!packageDiscountCheck) {
      //   handleToastError("Rates has been changed");
      //   return;
      // }
      goToKyc();
    }
  };

  const checkIfUserAlreadyExists = async (email) => {
    //console..log(email);
    try {
      let user = {
        email: email,
      };
      const result = await axios.post(endPoints.checkAlreadyUser, user);
      return result;
    } catch (error) {
      console.log("Error while check duplicate user " + error);
    }
  };

  const removeTimeSlots = (slot) => {
    setSelectedBands(
      selectedBands.filter((e) => {
        return e !== slot;
      })
    );
  };
  const addTimeSlots = () => {
    if (!selectedCustomfrom || !selectedCustomto) {
      handleToastError("Please select the time slots");
      return;
    }
    let duration = `${moment(selectedCustomfrom).format("HH:mm")}-${moment(
      selectedCustomto
    ).format("HH:mm")}`;
    let tempbands = [...selectedBands, duration];
    tempbands = [...new Set(tempbands)];
    setSelectedBands(tempbands);
  };
  //Apply a couponbassed on coupon code
  const applyCoupon = async () => {
    let totalCosts = packageCost + packageCost * 0.18;
    if (couponCode.length > 0) {
      try {
        const data = await axios.get(endPoints.applyCoupon, {
          params: {
            couponCode,
            email: userinfo.email,
          },
        });
        const result = data.data.data.data;
        debugger
        if (result && result.length === 0) {
          handleInvalid(true);
          handleValidClass("");
          handleInputClass("none");
        } else if (
          result &&
          result.length > 0 &&
          Date.now() - result[0].validUntil > 0
        ) {
          handleInvalid(false);
          handleValidClass("");
          handleExpiredCoupon(true);
          handleInputClass("none");
        } else if (
          result &&
          result.length > 0 &&
          result[0].type === "percentage"
        ) {
          handleValidClass("");
          handleInputClass("none");
          handleInvalid(false);
          handleExpiredCoupon(false);
          let couponAmount = Math.round(
            (result[0].discount * Number(packageCost)) / 100
          );
          handleCouponDiscount(result[0].discount);
          handleCouponType("percentage");
          // let packageCost = packageCost - couponAmount;
          handCouponAmount(couponAmount);
          // handlePackageCost(packageCost);
          handleCouponPercentage(Number(result[0].discount));
        } else if (
          result &&
          result.length > 0 &&
          result[0].type === "Flat Rate"
        ) {
          handleValidClass("");
          handleInputClass("none");
          handleInvalid(false);
          handleExpiredCoupon(false);
          let couponAmount = Math.round(result[0].discount);
          handleCouponDiscount(result[0].discount);
          handleCouponType("Flat Rate");
          debugger
          let totalCost = Number(packageCost) - couponAmount;
          handCouponAmount(couponAmount);
          // handleTotalCost(totalCost);
          handlePackageCost(totalCost)
        }
        getPackage()
        // calculateAgain(packageDetails[0].audioDuration);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const applyNONFCTCode = async () => {
    let totalCosts = packageCost + packageCost * 0.18;
    if (nonFCTCode.length > 0) {
      try {
        const data = await axios.get(endPoints.applyNONFCTCode, {
          params: {
            nonFCTCode,
            email: userinfo.email,
          },
        });
        const result = data.data.data.data;
        if (result && result.length === 0) {
          handleNonFCTInvalid(true);
          handleNonFCTValidClass("");
          handleNonFCTInputClass("none");
        } else if (
          result &&
          result.length > 0 &&
          Date.now() - result[0].validUntil > 0
        ) {
          handleNonFCTInvalid(false);
          handleNonFCTValidClass("");
          handleExpiredNONFCTCode(true);
          handleNonFCTInputClass("none");
        } else if (
          result &&
          result.length > 0
        ) {
          handleNonFCTValidClass("");
          handleNonFCTInputClass("none");
          handleNonFCTInvalid(false);
          handleExpiredNONFCTCode(false);
          let nonFCTAmount = Math.round(result[0].amount);
          // handleCouponDiscount(result[0].discount);
          // handleCouponType("Flat Rate");
          let totalCost = Number(packageCost) + nonFCTAmount;
          handleNonFCTCodeAmount(nonFCTAmount);
          // handleTotalCost(totalCost);
          handlePackageCost(totalCost)
        }
        getPackage()
        // calculateAgain(packageDetails[0].audioDuration);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleCouponInput = (e) => {
    let couponCode = e.target.value;

    if (couponCode.length <= 8) {
      handleCouponCode(couponCode);
    }
  };

  const handleNONFCTCodeInput = (e) => {
    handleNONFCTCode(e.target.value);
  };
  

  const handleCross = async () => {
    handleCouponCode("");
    handleInvalid(false);
    handleValidClass("none");
    handleInputClass("");
    handleExpiredCoupon(false);
    await handCouponAmount(undefined);
    if (couponAmount) {
      let nonFCTAmounts = nonFCTCodeAmount ? nonFCTCodeAmount : 0;
      let taxes = Math.round(packageCost + nonFCTAmounts) * 0.18
      taxes = Math.round(taxes)
      if(helpbigfmAudioOption){
        taxes = taxes + Math.round(audioCost * 0.18)
      }
      debugger
      handleTaxes(taxes);
      let totalCosts = Number(packageCost) + Number(nonFCTAmounts) + (taxes ? Number(taxes) : 0);
      // handleTotalCost(Math.round(Number(totalCosts) ));
      handleTotalCost(
        Math.round(Number(totalCosts) + ((option || previousAudioOption)? 0: Number(audioCost)))
      );
    }

  };

  const handleNONFCTCross = () => {
    handleNONFCTCode("");
    handleNonFCTInvalid(false);
    handleNonFCTValidClass("none");
    handleNonFCTInputClass("");
    handleExpiredNONFCTCode(false);
    handleNonFCTCodeAmount(undefined);
    if (nonFCTCodeAmount) {
      debugger
      // handleTotalCost(Math.round(Number(totalCost) - Number(nonFCTCodeAmount)));
      let taxes = Math.round(packageCost - (couponAmount ? couponAmount : 0)) * 0.18
      taxes = Math.round(taxes)
      if(helpbigfmAudioOption){
        taxes = taxes + Math.round(audioCost * 0.18)
      }
      handleTaxes(taxes);
      let totalCosts = Number(packageCost) + (taxes ? Number(taxes) : 0);
      // handleTotalCost(Math.round(Number(totalCosts) ));
      handleTotalCost(
        Math.round(Number(totalCosts) + ((option || previousAudioOption)? 0: Number(audioCost))- (couponAmount? couponAmount: 0))
      );

    }
  };

  //Handle the data for campaign
  const handleChangeLimit = (name, event) => {
    let { value } = event.target;
    if (value.length > 30) {
      name.current.value = name.current.value.slice(0, 30);
    }
  };
  // Existing Audio Popup
  const openPopup = (event) => {
    console.log(event.target.value);
    newToggle();
  };

  return (
    <div className="main_wrapper">
      {!salesuserinfo && <UserSideMenu {...props} />}
      {salesuserinfo && <SalesUserSideMenu {...props} />}
      <div className="dashboard_right_wrapper create_camp_container">
        <Model isShowing={isShowing} hide={toggle} packageCost={packageCost} />
        <NewModel
          isNewShowing={isNewShowing}
          hide={toggleNewMode}
          close={closeExistingAudioPopup}
        />

        <MultipleAudioModel 
          isShown={isMultipleAudioShowing}
          hide={toggleMultipleAudioModel}
          close={closeMultipleAudioPopup}
          packageDetails={packageDetails[0]}
        />
        <div className="right_wrapper_inner">
          {!salesuserinfo && <Header />}
          {salesuserinfo && <AuthHeader />}
          <div className="dash_content_wrapper">
            <div className="content_wrapper_inner">
              <div className="create_camp_wrapper">
                <div className="create_camp_details">
                  <h2 className="camp-detail_header">CREATE CAMPAIGN</h2>
                  <div className="camp_detail_header">
                    <h2>Campaign Details</h2>
                    <div className="detail_fied_wrapper">
                      <div className="field_wrapper">
                        <h6 className="camp_label">Campaign</h6>
                        <input
                          type="text"
                          className={isCampaignError ? "errors" : ""}
                          onChange={(event) =>
                            handleChangeLimit(campaignName, event)
                          }
                          ref={campaignName}
                          placeholder="Enter campaign name"
                          required
                        />
                      </div>
                      <div className="field_wrapper margin0">
                        <h6 className="camp_label">Brand Name</h6>
                        <input
                          type="text"
                          ref={brandName}
                          className={isBrandError ? "errors" : ""}
                          onChange={(event) =>
                            handleChangeLimit(brandName, event)
                          }
                          placeholder="Enter brand name"
                        />
                      </div>
                      <div className="field_wrapper">
                        <h6 className="camp_label">Product Category</h6>
                        <select
                          className={isProductError ? "errors" : ""}
                          onChange={(event) =>
                            handleProductName(event.target.value)
                          }
                          placeholder="Enter Product Category"
                        >
                          {industryList.map((o, i) => (
                            <option key={i} value={o.name}>
                              {o.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="field_wrapper margin0">
                        <h6 className="camp_label">
                          What is the objective of your campaign ?
                        </h6>
                        <select
                          onChange={(e) => {
                            handleObjective(e.target.value);
                          }}
                        >
                          {objectivesArray.map((o, i) => (
                            <option key={i} value={o}>
                              {o}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="field_wrapper icon_cal">
                        <h6 className="camp_label">Start Date</h6>
                        <label>
                          <DatePicker
                            placeholderText="Select Start Date"
                            dateFormat="dd/MM/yyyy"
                            minDate={minStartDate}
                            selected={startDate}
                            onSelect={handleDate}
                            className={isDateError ? "errors" : ""}
                            onChange={handleChange}
                          />
                          <img src="../../assets/images/cal_date.svg" />
                        </label>
                      </div>
                      <div className="field_wrapper margin0">
                        <h6 className="camp_label">
                          Sales Representative ID (Optional)
                        </h6>
                        <input
                          type="text"
                          ref={sallerId}
                          className={isSaleIdError ? "errors" : ""}
                          placeholder="Enter BIG FM Sales representative Email ID"
                          // value={
                          //   salesuserinfo &&
                          //   userinfo.email === salesuserinfo.email
                          //     ? salesuserinfo.email
                          //     : ""
                          // }
                          placeholder={defaultSalesUser}
                          disabled={
                            salesuserinfo &&
                            userinfo.email === salesuserinfo.email
                              ? true
                              : false
                          }
                        />
                      </div>

                      {/* <div className="audio_brief">
                      <h6 className="camp_label"> Audio Brief (Optional)</h6>
                        <textarea className="audio_brief" name="billing_Address"  value={audioBrief} 
                        onChange= {handleChangeAudio} placeholder="Enter Audio Brief">
                        </textarea>

                        </div> */}

                      {/* {!secondOption && <div className="field_wrapper margin0">

                        <h6 className="camp_label">Select Audio</h6>
                        <select onChange={(e) => {
                          handleSelectedPreviousAudio(e.target.value)
                        }}>
                          <option value=""  disabled >Select Your Audio</option>
                           {previousAudio.map((o, i) => <option key={i} value={o.audioUrl} >{o.name}</option>)}
                        </select>
                      </div>}*/}
                    </div>
{(!stations || stations.length == 0) &&
                    <div className="audio_wrapper">
                      <h4>Time Band</h4>
                      <div className="audio_raido_wrapper">
                        <div className="own_radio">
                          <input
                            className="audio_input"
                            type="radio"
                            id="Normal"
                            checked={bookingType !== "custom"}
                            name="booking-group"
                          />
                          <label
                            className="audio_label"
                            htmlFor="Normal"
                            onClick={() => {
                              setBookingType("normal");
                              getPackage();
                            }}
                          >
                            Regular
                          </label>
                        </div>
                        {/*<div className="own_radio or">OR</div>*/}
                        <div className="own_radio">
                          <input
                            className="audio_input"
                            type="radio"
                            id="customBooking"
                            checked={bookingType === "custom"}
                            name="booking-group"
                          />
                          <label
                            className="audio_label"
                            htmlFor="customBooking"
                            onClick={(event) => {
                              setBookingType("custom");
                              setShowPrimeMsg(true);
                            }}
                          >
                            Custom
                          </label>
                        </div>
                      </div>
                      {bookingType === "custom" && (
                        <React.Fragment>
                          {selectedBands.length > 0 && (
                            <div>
                              <h4>Selected Bands</h4>
                              {selectedBands.map((band) => {
                                return (
                                  <div style={{ marginBottom: "10px" }}>
                                    {band}{" "}
                                    <span
                                      className="clear_coupon"
                                      onClick={(e) => {
                                        removeTimeSlots(band);
                                      }}
                                    >
                                      <img src="../../assets/images/error.svg" />
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                          <div
                            style={{ width: "25%", display: "inline-block" }}
                          >
                            <h4>Start Time</h4>
                            <DatePicker
                              placeholderText="Select Start Time"
                              dateFormat="h:mm a"
                              onChange={setSelectedCustomfrom}
                              selected={selectedCustomfrom}
                              className={isDateError ? "errors" : ""}
                              includeTimes={timelimits}
                              showTimeSelect
                              // showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={60}
                            />
                          </div>
                          <div
                            style={{
                              width: "25%",
                              display: "inline-block",
                              marginLeft: "10px",
                            }}
                          >
                            <h4>End Time</h4>
                            <DatePicker
                              placeholderText="Select end Time"
                              dateFormat="h:mm a"
                              onChange={setSelectedCustomto}
                              selected={selectedCustomto}
                              includeTimes={timelimits}
                              className={isDateError ? "errors" : ""}
                              showTimeSelect
                              timeIntervals={60}
                              showTimeSelectOnly
                            />
                          </div>
                          <div
                            className="apply_btn"
                            style={{
                              display: "inline-block",
                              marginLeft: "10px",
                            }}
                          >
                            <button onClick={addTimeSlots}>ADD</button>
                          </div>
                        </React.Fragment>
                      )}
                    </div>
 } <div className="audio_wrapper">
                      <h4>Audio Jingle</h4>
                      <div className="audio_raido_wrapper">
                        <div className="own_radio">
                          <input
                            className="audio_input"
                            type="radio"
                            id="OwnRadio"
                            name="radio-group"
                          />
                          <label
                            className="audio_label"
                            htmlFor="OwnRadio"
                            onClick={() => {
                              handleOption(true);
                              handleFirstOption(true);
                              handlepreviousAudioOption(false);
                              handlehelpbigfmAudioOption(false);
                              handleuploadAudioleterOption(false);
                              handleSelectedMultiDurationAudio(false);
                              handleMinStartDate(null);
                              getPackage();
                              removeFile();
                              let taxvalue = Math.round(
                                (18 * packageCost) / 100
                              );
                              setCostValue
                              (
                                packageCost,
                                taxvalue,
                                undefined,
                                undefined,
                                undefined,
                                true
                              );
                            }}
                          >
                            Upload Audio
                          </label>
                        </div>
                        {/*<div className="own_radio or">OR</div>*/}
                        <div className="own_radio">
                          <input
                            className="audio_input"
                            type="radio"
                            id="existingAudio"
                            name="radio-group"
                          />
                          <label
                            className="audio_label"
                            htmlFor="existingAudio"
                            onClick={(event) => {
                              openPopup(event);
                              handleOption(false);
                              handleFirstOption(false);
                              handlepreviousAudioOption(true);
                              handleSelectedMultiDurationAudio(false);
                              handlehelpbigfmAudioOption(false);
                              handleuploadAudioleterOption(false);
                              handleMinStartDate(null);
                              // getPackage();
                              let taxvalue = Math.round(
                                (18 * packageCost) / 100
                              );
                              setCostValue(
                                packageCost,
                                taxvalue,
                                undefined,
                                undefined,
                                undefined,
                                true
                              );
                            }}
                          >
                            Existing Audio
                          </label>
                        </div>
                        <div className="own_radio">
                          <input
                            className="audio_input"
                            type="radio"
                            id="existingAudioMultiple"
                            name="radio-group"
                          />
                          <label
                            className="audio_label"
                            htmlFor="existingAudioMultiple"
                            onClick={(event) => {
                              multipleAudioToggle();
                              handleOption(false);
                              handleFirstOption(false);
                              handlepreviousAudioOption(false);
                              handleSelectedMultiDurationAudio(true);
                              handlehelpbigfmAudioOption(false);
                              handleuploadAudioleterOption(false);
                              handleMinStartDate(null);
                              // getPackage();
                              let taxvalue = Math.round(
                                (18 * packageCost) / 100
                              );
                              setCostValue(
                                packageCost,
                                taxvalue,
                                undefined,
                                undefined,
                                undefined,
                                true
                              );
                            }}
                          >
                            Multi Duration Audio
                          </label>
                        </div>
                      </div>
                      <div className="audio_raido_wrapper">
                        {/*<div className="own_radio or">OR</div>*/}
                        <div className="own_radio">
                          <input
                            className="audio_input"
                            type="radio"
                            id="createAudio"
                            name="radio-group"
                          />
                          <label
                            className="audio_label"
                            htmlFor="createAudio"
                            onClick={() => {
                              handleOption(false);
                              handleFirstOption(false);
                              handlepreviousAudioOption(false);
                              handlehelpbigfmAudioOption(true);
                              handleuploadAudioleterOption(true);
                              getMinDateBassedOnTypeOfFile();
                              calculateAgain(packageDetails[0].audioDuration);
                            }}
                          >
                            Help from Big FM Create Audio
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="lenght_file_wrapper">
                      <div className="flie_audio">
                        {!uploadedAudio && !multipleAudios && option && (
                          <div className={uploadAudio}>
                            <h6>Upload Audio File</h6>
                            <Drag getUploadedFile={getUploadedFile} />
                            <div className="file_size">
                              Size of audio file should be less than 5MB. Only
                              mp3 files are supported
                            </div>
                          </div>
                        )}

                        {uploadedAudio && uploadedAudios.length == 0 && option && (
                          <div className="upload_file">
                            <h6>Uploaded audio File</h6>
                            <div>
                              <div className="audio_img">
                                {" "}
                                <img src="../../assets/images/song.svg" />
                              </div>
                              <div className="file_desc">
                                <div className="file_name_size">
                                  <div className="file_name">
                                    {uploadedAudio.path}
                                  </div>
                                  <span className="file_size">
                                    Audio length :{" "}
                                    {packageDetails[0].type === "Rotation Based"
                                      ? actualAudioLength + " Sec"
                                      : actualAudioLength + " Sec"}
                                  </span>
                                </div>
                                <div className="remove_file">
                                  <span className="filesize">
                                    {fileSizeWithLimit}
                                  </span>
                                  <a onClick={removeFile}> REMOVE</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {(option || previousAudioOption) && uploadedAudios && uploadedAudios.length > 0 && (
                          <h6>Uploaded audio Files</h6>
                        )}
                        {(option || previousAudioOption) && uploadedAudios && uploadedAudios.length > 0 &&
                          uploadedAudios.map((audio) => {
                            return (
                              <div className="upload_file">
                                <div>
                                  <div className="audio_img">
                                    {" "}
                                    <img src="../../assets/images/song.svg" />
                                  </div>
                                  <div className="file_desc">
                                    <div className="file_name_size">
                                      <div className="file_name">
                                        {audio.path
                                          ? audio.path
                                          : audio.fileName}
                                      </div>
                                      <span className="file_size">
                                        Audio length :{" "}
                                        {packageDetails[0].type ===
                                        "Rotation Based"
                                          ? actualAudioLength + " Sec"
                                          : actualAudioLength + " Sec"}
                                      </span>
                                    </div>
                                    <div className="remove_file">
                                      <span className="filesize">
                                        {fileSizeWithLimit}
                                      </span>
                                      <a
                                        onClick={() => {
                                          removeFileInCollection(
                                            audio.path
                                              ? audio.path
                                              : audio.fileName
                                          );
                                        }}
                                      >
                                        {" "}
                                        REMOVE
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          { selectedMultiDurationAudio && multipleAudios && multipleAudios.length > 0 ? (
                              <div style={{marginTop: "1em", marginBottom: "1em"}}>
                                <h3 style={{marginTop: "1em", marginBottom: "1em"}}>Selected Multi Duration Audio details</h3>
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th>Audio File Name</th>
                                      <th>Audio Length</th>
                                      <th>Number of Days</th>
                                      <th>Rotations per Day</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                  {multipleAudios.map((audio) => {
                                    return (
                                      <tr>
                                        <td>{audio.audio}</td>
                                        <td>{audio.audioLength} Seconds</td>
                                        <td>{audio.numberOfDays}</td>
                                        <td>{audio.rotationsPerDay}</td>
                                      </tr>
                                    );
                                  })}
                                  </tbody>
                                </table>
                              </div>
                              
                          ) : ''}
                        {localStorage.getItem("ExistingAudioUrl") &&
                          previousAudioOption && (
                            <div className="upload_file">
                              <h6>Uploaded audio File</h6>
                              <div>
                                <div className="audio_img">
                                  {" "}
                                  <img src="../../assets/images/song.svg" />
                                </div>
                                <div className="file_desc">
                                  <div className="file_name_size">
                                    <div className="file_name">
                                      {process.env.DOMAIN +
                                      "/" +
                                      localStorage.getItem("ExistingAudioUrl")
                                        ? localStorage.getItem(
                                            "ExistingAudioUrl"
                                          )
                                        : ""}
                                    </div>
                                    <span className="file_size">
                                      Audio length :{" "}
                                      {packageDetails[0].type ===
                                      "Rotation Based"
                                        ? localStorage.getItem(
                                            "ExistingAudioDuration"
                                          ) + " Sec"
                                        : localStorage.getItem(
                                            "ExistingAudioDuration"
                                          ) + " Sec"}
                                    </span>
                                  </div>
                                  <div className="remove_file">
                                    <span className="filesize">
                                      {fileSizeWithLimit}
                                    </span>
                                    <a onClick={removeFile}> REMOVE</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        {helpbigfmAudioOption && (
                          <div className="creation_cost">
                            <h6>Audio Creation Cost</h6>
                            <div className="create_cost">
                              <span className="cost_rupee_symb">
                                {" "}
                                <img src="../../assets/images/rupee-indian.svg" />
                              </span>
                              <span className="camp_cost">{audioCost}</span>
                              <p>
                                This amount will be added to your package cost
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="create_camp_cost">
                  <div className="camp_cost_card">
                    <div className="apply_coupon">
                      <h5>Apply Coupon</h5>
                      <div className={`enter_coupon ${inputClass}`}>
                        <div className="coupon_input">
                          <input
                            type="text"
                            value={couponCode}
                            placeholder="Enter Coupon Code here"
                            onChange={handleCouponInput}
                          />
                        </div>
                        <div className="apply_btn">
                          <button onClick={applyCoupon}>APPLY</button>
                        </div>
                      </div>
                      <div className={`coupon_filled ${validClass}`}>
                        <div className="coupon_name">
                          {couponCode}
                          <span className="clear_coupon" onClick={handleCross}>
                            <img src="../../assets/images/error.svg" />
                          </span>
                        </div>
                        {couponAmount && !couponPercentage && (
                          <p className="congrat_msg">
                            Congratulations! your have applied Flat
                            <span className="coupon_rupee">
                              <img src="../../assets/images/rupee-indian.svg" />
                              {couponAmount}
                            </span>{" "}
                            discount on the campaign cost
                          </p>
                        )}
                        {couponAmount && couponPercentage && (
                          <p className="congrat_msg">
                            Congratulations! your have applied Flat
                            <span className="coupon_rupee">
                              {" "}
                              {couponPercentage} %
                            </span>{" "}
                            discount on the campaign cost
                          </p>
                        )}
                        {invalid && (
                          <p className="congrat_msg">Invalid Coupon</p>
                        )}
                        {expiredCoupon && <p>Your Coupon has Expired</p>}
                      </div>
                    </div>

                    <div className="apply_coupon">
                      <h5>Apply NON FCT Code</h5>
                      <div className={`enter_coupon ${nonFCTInputClass}`}>
                        <div className="coupon_input">
                          <input
                            type="text"
                            value={nonFCTCode}
                            placeholder="Enter NON FCT Code here"
                            onChange={handleNONFCTCodeInput}
                          />
                        </div>
                        <div className="apply_btn">
                          <button onClick={applyNONFCTCode}>APPLY</button>
                        </div>
                      </div>
                      <div className={`coupon_filled ${nonFCTValidClass}`}>
                        <div className="coupon_name">
                          {nonFCTCode}
                          <span className="clear_coupon" onClick={handleNONFCTCross}>
                            <img src="../../assets/images/error.svg" />
                          </span>
                        </div>
                        {nonFCTCodeAmount && (
                          <p className="congrat_msg">
                            Congratulations! your have applied Non-FCT Code
                            <span className="coupon_rupee">
                              <img src="../../assets/images/rupee-indian.svg" />
                              {nonFCTCodeAmount}
                            </span>{" "}
                            added on the campaign cost
                          </p>
                        )}
                        {nonFCTInvalid && (
                          <p className="congrat_msg">Invalid NON FCT Code</p>
                        )}
                        {expiredNONFCTCode && <p>Your Coupon has Expired</p>}
                      </div>
                    </div>

                    <h5>Campaign Details</h5>
                    {stations && stations.length == 0 && (
                      <li className="cost_list_inner">
                        <div className="cost_type"> Station Name </div>
                        <div>
                          {" "}
                          <span className="cost_inner">{station}</span>{" "}
                        </div>
                      </li>
                    )}
                    {stations && stations.length > 0 && (
                      <li className="cost_list_inner">
                        <div className="cost_type"> Station Name </div>
                        <div>
                          {" "}
                          <span className="cost_inner" onClick={(e) => {
                                  handleshowstationlist(true);
                                  handleCurrentStations(stations);
                                }}
                                style={{cursor:"pointer"}}>
                           Multiple({stations.length})
                          </span>{" "}
                        </div>
                      </li>
                    )}

                    <li className="cost_list_inner">
                      <div className="cost_type"> Package Type </div>
                      <div>
                        {" "}
                        <span className="cost_inner">
                          {packageDetails[0].type}
                        </span>{" "}
                      </div>
                    </li>

                    {/* === "Rotation Based" */}

                    <h5>Campaign Cost</h5>
                    <ul className="camp_cost_list">
                      <li className="cost_list_inner">
                        <div className="cost_type">Package Cost</div>
                        <div className="rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{packageCost}</span>
                        </div>
                      </li>

                      {audioCost && audioCost && helpbigfmAudioOption && (
                        <li className="cost_list_inner">
                          <div className="cost_type">Audio Cost</div>
                          <div className="rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">{audioCost}</span>
                          </div>
                        </li>
                      )}

                      {/* {audioCost && audioCost && uploadAudioleterOption &&
                      <li className="cost_list_inner">
                        <div className="cost_type">Audio Cost</div>
                        <div className="rupee_symb"><img src="../../assets/images/rupee-indian.svg" /><span className="cost_inner">{audioCost}</span></div>
                      </li>} */}

                      {couponAmount && (
                        <li className="cost_list_inner">
                          <div className="cost_type coupon_discount">
                            Coupon Discount
                          </div>
                          <div className="rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">{couponAmount}</span>
                          </div>
                        </li>
                      )}
                      { nonFCTCodeAmount && (<li className="cost_list_inner">
                        <div className="cost_type">Non FCT Amount</div>
                        <div className="rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{nonFCTCodeAmount}</span>
                        </div>
                      </li>
                      )}
                      <li className="cost_list_inner">
                        <div className="cost_type">Taxes@18%</div>
                        <div className="rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{taxes}</span>
                        </div>
                      </li>
                      <div className="totalcost">
                        <div className="cost_type ">Total Cost</div>
                        <div className="rupee_symb">
                          <img src="../../assets/images/rupee-indian_white.svg" />
                          <span className="cost_inner">{totalCost}</span>
                        </div>
                      </div>
                      {bookingType === "custom" && (
                        <li className="cost_list_inner">
                          <div className="cost_type">
                            Note! Premium cost of {packageDetails[0].customrodp}
                            % applied with the base price
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="cost_button">
                    <button className="cncl" onClick={toggle}>
                      CANCEL
                    </button>
                    <button className="procd" onClick={payAmount}>
                      PROCEED
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      {fileLimitModel && (
        <CommonModelImpl
          msg={customMsg}
          okButtonShow={true}
          okButtonText="Accept"
          okAction={acceptFileExccedLimit}
          cancelButtonShow={true}
          cancelButtonText="Change Package"
          cancelAction={changeSlot}
        />
      )}
      {minValueMet && (
        <CommonModelImpl
          msg={minAmountMsg}
          okButtonShow={true}
          okButtonText="OK"
          okAction={removeFile}
          cancelAction={removeFile}
        />
      )}
      {showPrimeMsg && (
        <CommonModelImpl
          msg={primeAmountMsg}
          okButtonShow={true}
          okButtonText="Accept"
          okAction={setToPrime}
          cancelAction={setToRegular}
          cancelButtonShow={true}
          cancelButtonText="Decline"
        />
      )}
      {showstationlist && (
                <ShowStations
                  stations={currentStations}
                  closeAction={hideshowstations}
                />
              )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    audios: state.user.get("audio"),
  };
};

export default connect(mapStateToProps, { audio })(Campaign);



// WEBPACK FOOTER //
// ./web/components/campaign/CreateCompaign.jsx